// extracted by mini-css-extract-plugin
export default {"empty":"EmptyTable_empty__G88Oj"};